import {
    CssBaseline,
    StyledEngineProvider,
    ThemeProvider,
} from "@mui/material";
import React from "react";
import AppTheme from "Theme/AppTheme";
import AuthPage from "./AuthPage";

function AppLoadingScreen() {
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={AppTheme}>
                <CssBaseline />
                <AuthPage
                    title="Welcome to Authenticx"
                    subtitle="Loading..."
                    isLoading
                />
            </ThemeProvider>
        </StyledEngineProvider>
    );
}

export default AppLoadingScreen;
